(function ($) {
	cohesion("fuse:done", function (err) {
		$(".js-click-to-call-target").each( function () {
			var num = $( this ).find(".js-click-to-call").text();
			if (num !== "844-262-5082") {
				$(".js-click-to-call-target").attr( "href", "tel:+1-" + num );
			}
		});
	});
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/partials/fuse.js